import CommonHeadings from "helper/constant/headings";
import Dateformat from "helper/constant/timeFormat";
import React, { useEffect, useLayoutEffect, useState } from "react";
import Moment from "react-moment";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { query, collection, orderBy, getDocs, where } from "firebase/firestore";
import { dbFirestore } from "helper/config/firebase";
import TableName from "helper/tableName/tableName";
import moment from "moment";
import { Calendar } from "primereact/calendar";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "primereact/button";

function TeachersAttedanceView() {
  const [teacherData, setTeacherData] = useState([]);
  const [dates, setDates] = useState(new Date());
  const location = useLocation();
  const navigate = useNavigate();

  // MARK: Use Layout Method
  useLayoutEffect(() => {
    document.title = "Teacher Attendance";
  }, []);

  useEffect(() => {
    const date = new Date();
    findMonthStartandEnd(date);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function findMonthStartandEnd(date) {
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    const momentStartDate = moment(new Date(firstDay)).format("YYYY-MM-DD");
    const momentEndDate = moment(new Date(lastDay)).format("YYYY-MM-DD");
    fetchStudentsAttendanceApi(momentStartDate, momentEndDate);
  }

  const inputChange = (e) => {
    const date = e.value;
    setDates(date);
    findMonthStartandEnd(date);
  };

  // MARK: taecher columns data
  const teachersColumns = [
    {
      field: "date",
      header: "Date",
      CardBody: (teacherModal) => (
        <Moment format={Dateformat.DDMMYYYY}>{teacherModal.date}</Moment>
      ),
    },
  ];

  // MARK: fetch student attendance data
  async function fetchStudentsAttendanceApi(startDate, endDate) {
    const id = location.state.id;

    let q = query(
      collection(dbFirestore, TableName.teacherAttendance),
      where("attendance", "array-contains", id),
      where("date_value", ">=", startDate),
      where("date_value", "<=", endDate),
      orderBy("created_at", "desc")
    );

    const querySnapshot = await getDocs(q);

    const array = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
    }));

    setTeacherData(array);
  }

   //MARK: teacher Name
   const teacherName = () => {
    return (
      <>
        <div>
          <p className="table__column__capital ms-0">Teacher Name: {location.state.name}</p>
        </div>
      
      </>
    );
  };

  const header = teacherName();

  return (
    <div className="modules__main__div">
      <div className="col-12">
        <div className="card modules__card mt-5">
          <div className="modules__lists_main-content">
            <h5 className="flex-grow-1" style={{ textTransform: "capitalize" }}>
              leave & attendance
            </h5>
            <Button 
              label="Back"
              type="button"
              onClick={() => navigate(-1)}
              className="view__back_button"
            />
          </div>
          <div className="mt-3 mb-5">
            <Calendar
              value={dates}
              onChange={inputChange}
              view="month"
              dateFormat="mm/yy"
              showIcon
              placeholder="mm/yyyy"
            />
          </div>
          <DataTable header={header}
            className="mb-3"
            value={teacherData}
            emptyMessage="No data found."
          >
            {teachersColumns.map((col) => (
              <Column className="table__column__capital"
                key={col.field}
                field={col.field}
                header={col.header}
                bodyClassName={col.className}
                body={col.CardBody}
              />
            ))}

            {teacherData && (
              <Column field="status" header="Status" body="Present"></Column>
            )}
          </DataTable>
        </div>
      </div>
    </div>
  );
}

export default TeachersAttedanceView;
